import { SuggestionsList } from './suggestions-list';
import { Brands } from './brands';
import React from 'react';
import { useTranslation } from 'react-i18next';

type BrandsListProps = {
  suggestionSelector: string;
  searchQuery: string;
};

export const BrandsList: React.FC<BrandsListProps> = ({ suggestionSelector, searchQuery }) => {
  const { t } = useTranslation();

  return (
    <SuggestionsList
      suggestionSelector={suggestionSelector}
      withTitle={false}
      withDivider={false}
      title={t('header.searchbar.brands')}
      aria-label={t('header.searchbar.brands-aria')}
      data-qa={'service-brands'}
    >
      <Brands searchQuery={searchQuery} />
    </SuggestionsList>
  );
};
